import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Modal from 'react/components/Modal';
import MonetUser from 'react/monet/fields/user.jsx';
import { actionCreators } from 'react/api/actions/chatTicketActions';
import { getResourceTo } from 'react/utils/chatUtils';

const ReassignCall = ({
  isOpen,
  ticket,
  toggleModal,
  submitReassign,
  userId,
  userName,
  companyId,
  ...others
}) => {
  /** Reasign type ENUM */
  const { ALL_USERS, SPECIFIC_USER } = {
    ALL_USERS: 1,
    SPECIFIC_USER: 2
  };

  const [reassignType, setReassignType] = useState(ALL_USERS);
  const [selectedUser, setSelectedUser] = useState(null);

  function selectAllUsers() {
    setReassignType(ALL_USERS);
  }

  function selectSpecificUser() {
    setReassignType(SPECIFIC_USER);
  }

  function handleSelectUser(field, value) {
    setSelectedUser(value);
  }

  function handleSubmit() {
    const ticketId = ticket.get('ticketId');

    const data = reassignType === ALL_USERS ? {
      userId,
      userName,
      companyId,
      ticketId
    } : {
      userId,
      userName,
      companyId,
      ticketId,
      toUserId: selectedUser
    };

    if (reassignType === SPECIFIC_USER && !selectedUser) {
      return;
    }

    submitReassign(data);
  }

  function clearData() {
    setReassignType(1);
    setSelectedUser(null);
  }

  const footer = () => (
    <>
      <input
        type="button"
        className="btn closeButton"
        value={getResourceTo('default.button.cancel')}
        onClick={() => toggleModal()}
      />
      <input
        type="button"
        className="btn submitButton"
        value={getResourceTo('Greenmile.Chat.ReasignTicketModal.SubmitButton')}
        onClick={handleSubmit}
      />
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      onAfterClose={clearData}
      closeModalFn={() => toggleModal()}
      title={getResourceTo('Greenmile.Chat.ReasignTicketModal.Title')}
      crossAxisBtn={false}
      className="reassignCallModal"
      footer={footer()}
      {...others}
    >
      <div className="text">
        <p>{getResourceTo('Greenmile.Chat.ReasignTicketModal.Text')}</p>
      </div>
      <div className="form">
        <div className="form-block">
          <input
            type="radio"
            name="reasign-type"
            checked={reassignType === ALL_USERS}
            onClick={selectAllUsers}
            onChange={selectAllUsers}
          />
          <label onClick={selectAllUsers}>
            {getResourceTo('Greenmile.Chat.ReasignTicketModal.Radio.AllUsers')}
          </label>
        </div>
        <div className="form-block">
          <input
            type="radio"
            name="reasign-type"
            checked={reassignType === SPECIFIC_USER}
            onClick={selectSpecificUser}
            onChange={selectSpecificUser}
          />
          <label onClick={selectSpecificUser}>
            {getResourceTo('Greenmile.Chat.ReasignTicketModal.Radio.SpecificUser')}
          </label>
        </div>
        {reassignType === SPECIFIC_USER && (
        <div className="monet-field">
          <label>{getResourceTo('Greenmile.Chat.ReasignTicketModal.Lookup.Label')}</label>
          <MonetUser
            userId={userId}
            afterSelectRow={handleSelectUser}
            availableUsers={ticket && ticket?.get('availableUsersIds')?.toJS()}
            availableGroups={ticket && ticket?.get('availableGroupsIds')?.toJS()}
          />
        </div>
        )}
      </div>
    </Modal>
  );
};

ReassignCall.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  submitReassign: PropTypes.func.isRequired,
  ticket: PropTypes.object,
  userId: PropTypes.number,
  userName: PropTypes.string,
  companyId: PropTypes.number
};

ReassignCall.defaultProps = {
  ticket: null,
  userId: 0,
  userName: '',
  companyId: 0
};

const mapStateToProps = ({ chatTicketActions, configuration }) => ({
  isOpen: chatTicketActions.getIn(['modalReassignCallIsOpen'], false),
  ticket: chatTicketActions.getIn(['activeTicket']),
  userId: configuration?.loggedUser?.id,
  userName: configuration?.loggedUser?.name,
  companyId: configuration?.globalConfiguration?.authConfigId
});

const mapDipatchToProps = {
  toggleModal: actionCreators.toggleReassignCallModal,
  submitReassign: actionCreators.submitReassignCall
};

export default connect(mapStateToProps, mapDipatchToProps)(ReassignCall);
